import { render } from "./Index.vue?vue&type=template&id=a5cd00de&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=a5cd00de&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=a5cd00de&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1646527654/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5cd00de"]])

export default __exports__